import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Typography from "@mui/material/Typography";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import FormProvider from "./FormProvider";
import DirectionSnackbar from "../Alert/Alert";
import TextFieldicon from "./TextField_icon";
import LoadingButton from "@mui/lab/LoadingButton";
import Loading from "../Loading/CircularDeterminate";
import bcrypt from "bcryptjs";
import { useAuth } from "../Auth/AuthProtecter";

export default function FormOther({ name, ...pros }) {
  const url = process.env.REACT_APP_API_UPDATE_PASS; // Conection Api

  const [data, setArrayUser] = React.useState(true);
  const [iduser, setId] = useState(pros.id);
  const [status, setStatus] = useState(false);
  const [messenger, setMessenger] = useState("");
  const [severity, setSeverity] = useState("");

  const salt = bcrypt.genSaltSync(10);

  const RegisterSchema = Yup.object().shape({
    code: Yup.string()
      .required("Documento vacio")
      .min(10, "Lo minimo son 10 caracteres")
      .max(10, "El numero de documento muy largo"),
    username: Yup.string()
      .required("Nombre de usuario no puede estar vacio")
      .min(4, "lo minimo son 4 caracteres"),
    email: Yup.string()
      .email("Ingrese un Email valido ejemplo: proyect_bussines@correo.com")
      .required("El Email es Requerido."),
    pass: Yup.string()
      .required("No se proporcionó contraseña.")
      .min(
        8,
        "La contraseña es demasiado corta; debe tener un mínimo de 8 caracteres."
      )
      .matches(/[a-zA-Z]/, "La contraseña debe contener letras."),
    pass2: Yup.string().oneOf(
      [Yup.ref("pass"), null],
      "Las contraseñas deben coincidir"
    ),
  });

  const defaultValues = {
    username: "0",
  };
  // const defaultValues = {
  //   username: data["name"],
  //   code: data["code"],
  //   email: data["email"],
  //   pass: "",
  //   pass2: "",
  // };

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (e) => {
    const passbcry = bcrypt.hashSync(e.pass, salt);

    const values = {
      name: e.username,
      code: e.code,
      email: e.email,
      pass: passbcry,
      pass2: salt,
    };

    try {
      const CONFIG_JSON = {
        method: "POST",
        headers: {
          referrerPolicy: "unsafe_url",
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          mode: "same-origin",
        },
        body: JSON.stringify(values),
      };

      const res = await fetch(`${url}${iduser}`, CONFIG_JSON);
      // const res_api = await res.json();

      if (res.status === 200) {
        setStatus(true);
        setMessenger("Ajustes actualizados");
        setSeverity("success");
      }

      if (res.status !== 200) {
        setStatus(true);
        setMessenger("Ocurrio un error...");
        setSeverity("error");
      }

      window.setTimeout(() => {
        setStatus(false);
      }, 4000);
    } catch (error) {
      if (error) {
        setStatus(true);
        setMessenger("Ups, error de conexión...");
        setSeverity("error");
      }

      window.setTimeout(() => {
        setStatus(false);
      }, 4000);
    }
  };

  const auth = useAuth();
  const { person, email } = auth.infoUserDasboard;

  const [datai, setArrayUseri] = React.useState(false);

  useEffect(() => {
    //
    setArrayUser(person);
    //
  });

console.log(person)

  return datai ? (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Otros datos
      </Typography>
      <DirectionSnackbar
        open={status}
        severity={severity}
        messenger={messenger}
      />
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextFieldicon
              id="documentid"
              name="documentid"
              label="Documento"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFieldicon type="date" id="date" label="Fecha de nacimiento" />
          </Grid>
        </Grid>{" "}
        <Typography
          sx={{
            marginTop: 3,
          }}
          variant="h6"
          gutterBottom
        >
          Cambio de correo y contraseña
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextFieldicon id="email" name="email" label="Correo electronico" />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextFieldicon
              type="password"
              id="pass"
              name="pass"
              label="Contraseña"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFieldicon
              type="password"
              id="pass2"
              name="pass2"
              label="Repetir contraseña"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LoadingButton
              sx={{ mt: 2, mb: 2 }}
              fullWidth
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              Guardar cambios
            </LoadingButton>
          </Grid>
        </Grid>
      </FormProvider>
    </React.Fragment>
  ) : (
    <>
      <Loading />
    </>
  );
}
